
<template>
  <!-- 搜案例 -->
  <div class="background_box">
    <div class="box">
      <div class="case">
        <div class="advanced_search">
          <div class="carousel" style="">
            <img
              src="../../../assets/imgs/素材/棕黄色logo.png"
              style="width: 50px"
              alt=""
            />
          </div>
          <el-tabs style="margin: 0 0 0 12px">
            <div style="display: flex; position: relative">
              <el-input
                placeholder="请输入检索内容"
                v-model="input"
                class="input-with-select tit_input"
                @keyup.enter.native="newSearch"
                clearable
              >
                <el-select
                  v-model="select"
                  slot="prepend"
                  placeholder="请选择"
                  style="width: 120px"
                  class="titSelect"
                >
                  <el-option
                    label="全文"
                    value="Content"
                    style="text-align: center"
                  ></el-option>
                  <el-option
                    label="标题"
                    value="Casename"
                    style="text-align: center"
                  ></el-option>

                  <el-option
                    label="案号"
                    value="CaseId"
                    style="text-align: center"
                  ></el-option>
                  <el-option
                    label="案情描述"
                    value="case_description"
                    style="text-align: center"
                  ></el-option>
                </el-select>
              </el-input>

              <el-button
                type="warning"
                @click="newSearch"
                style="width: 80px"
                class="search_button"
                >检索</el-button
              >

              <el-button type="warning" @click="seniorCase" style=""
                >高级检索 >></el-button
              >
            </div>
            <div style="margin: 10px 0 0 0">
              <el-radio-group
                v-model="radio01"
                :class="
                  select == 'CaseId' || select == 'case_description'
                    ? ''
                    : 'radio_css'
                "
              >
                <el-radio
                  :disabled="select == 'CaseId' || select == 'case_description'"
                  :label="'2'"
                  @change="accuracy('2')"
                  >模糊检索</el-radio
                >
                <el-radio
                  :disabled="select == 'CaseId' || select == 'case_description'"
                  :label="'1'"
                  @change="accuracy('1')"
                  >精准检索</el-radio
                >
              </el-radio-group>
            </div>
            <div class="conditions">
              <div class="condition">
                <div>搜索条件</div>
                <div class="eltags">
                  <div v-for="(item, ind) in condition" :key="ind + 'item'">
                    <el-tag
                      v-if="Array.isArray(item[1]) && item[1].length > 0"
                      closable
                      type="warning"
                      @close="handleClose(item[0], ind)"
                      :style="
                        item.type == 'word'
                          ? 'white-space: normal;height: auto;display: flex;align-items: center;'
                          : ''
                      "
                    >
                      <span v-if="item[0] == 'Casename'">标题：</span>
                      <span v-if="item[0] == 'Content'">全文：</span
                      ><span v-if="item[0] == 'CaseId'">案号：</span>
                      <span v-if="item[0] == 'case_description'"
                        >案情描述：</span
                      >

                      <span v-if="item[0] == 'Leval'">法院级别：</span>
                      <span v-if="item[0] == 'Court'">地区：</span>

                      <span v-if="item[0] == 'Reason'">案由：</span>
                      <span v-if="item[0] == 'Ref_level'">参照级别：</span>
                      <span v-if="item[0] == 'TrialPro'">审判程序：</span>
                      <span v-if="item[0] == 'RefereeDate'">时间：</span>
                      <span v-if="item[0] == 'DocType'">文书类型：</span>
                      <span v-if="item[0] == 'Keyword'">关键词：</span>
                      <span v-if="item[0] == 'Party'">当事人：</span>
                      <span v-if="item[0] == 'Lawfirm'">代理律所：</span>
                      <span v-if="item[0] == 'Lawer'">代理律师：</span>
                      <!-- <span v-if="item[0] == 'Content'">裁判结果：</span> -->
                      <span v-if="item[0] == 'CaseType'">案件类型：</span>
                      <span v-if="item[0] == 'Fee'">诉讼费用：</span>
                      <span
                        v-if="
                          item[1].length > 0 &&
                          item[1].length <= 1 &&
                          item[0] !== 'Fee'
                        "
                      >
                        <span v-if="item[0] == 'RefereeDate'" class="aa">
                          <span
                            >{{ item[1][0][0] }} -- {{ item[1][0][1] }}</span
                          >
                        </span>
                        <span v-else-if="item[0] == 'Fee'">
                          <span
                            >{{ item[1][0][0] }} -- {{ item[1][0][1] }}</span
                          >
                        </span>
                        <span v-else>
                          <span
                            v-if="
                              Array.isArray(item[1][0]) &&
                              item[1][0].length == 3
                            "
                          >
                            <span v-if="item[0] !== 'case_description'">{{
                              item[1][0][1]
                            }}</span>

                            <el-tooltip
                              v-else
                              class="item"
                              effect="light"
                              popper-class="tip-class"
                              :content="item[1][0][1]"
                              placement="bottom"
                              style="cursor: pointer; width: 500px"
                            >
                              <span>{{
                                truncateString(item[1][0][1], 12)
                              }}</span>
                            </el-tooltip>
                          </span>

                          <span
                            v-if="
                              Array.isArray(item[1][0]) &&
                              item[1][0].length == 2
                            "
                            >{{ item[1][0][0] }}</span
                          >
                          <span v-if="!Array.isArray(item[1][0])">{{
                            item[1][0].replace(/[0-9]/g, "")
                          }}</span>
                        </span>
                      </span>
                      <!-- replace(/[0-9]/g, "") -->
                      <span v-if="item[1].length > 1 && item[0] !== 'Fee'">
                        <span
                          class="word_tag"
                          v-for="(item_s, index) in item[1]"
                          :key="index"
                        >
                          <span
                            v-if="
                              (item_s[0] == 'and' ||
                                item_s[0] == 'or' ||
                                item_s[0] == 'not') &&
                              index > 0
                            "
                            class="or_"
                            >{{ item_s[0] }}</span
                          >
                          <span
                            v-else-if="index > 0 && item[0] !== 'Party'"
                            class="or_"
                            >or</span
                          >
                          <span
                            v-else-if="index > 0 && item[0] == 'Party'"
                            class="or_"
                            >and</span
                          >
                          <el-tag
                            closable
                            size="mini"
                            @close="handleClose_one(item[0], index)"
                          >
                            <span v-if="item[0] == 'RefereeDate'">
                              <span>{{ item_s[0] }} -- {{ item_s[1] }}</span>
                            </span>
                            <span v-else-if="Array.isArray(item_s)">
                              <span v-if="item_s.length == 3">{{
                                item_s[1]
                              }}</span>
                              <span v-if="item_s.length == 2">{{
                                item_s[0]
                              }}</span>
                            </span>
                            <span v-else>
                              {{ item_s.replace(/[0-9]/g, "") }}
                            </span>
                          </el-tag>
                        </span>
                      </span>
                      <span v-if="item[0] == 'Fee'">
                        {{ item[1][0] }} -- {{ item[1][1] }}
                      </span>
                    </el-tag>
                  </div>
                </div>
              </div>
              <div class="savebtn">
                <i class="el-icon-delete" @click="remove">清空条件</i>
              </div>
            </div>
          </el-tabs>
        </div>
        <div class="box_botton" style="">
          <div class="box_left" v-if="show_">
            <el-menu
              default-active="2"
              class="el-menu-vertical-demo"
              :default-openeds="openeds"
            >
              <el-submenu index="1">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/2.png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >法院级别</span
                  >
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="levalData"
                    :props="leval"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="courtClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="char_.includes(data.key) ? 'color: #e6a23c;' : ''"
                      slot-scope="{ node, data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          node.label
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                    </span>
                  </el-tree>
                </div>
              </el-submenu>

              <el-submenu index="2">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/2(1).png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px">地区</span>
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="moreall ? courtData : courtData.slice(0, 10)"
                    :props="court"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    accordion
                    :expand-on-click-node="false"
                    @node-click="regionClick"
                    :default-expand-all="defaultall"
                    class="region cityClass"
                    style="padding-left: 20px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="
                        char_.includes(commas_left + data.name + commas_left)
                          ? 'color: #e6a23c;'
                          : ''
                      "
                      slot-scope="{ node, data }"
                    >
                      <span style="padding-bottom: 10px !import"
                        ><span style="font-weight: 900 !important">{{
                          node.label
                        }}</span>
                        ({{ data.count }})</span
                      >
                    </span>
                  </el-tree>
                  <span
                    v-if="courtData.length > 10"
                    @click="more"
                    v-show="moreShow"
                    class="more"
                    style=""
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="5">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/2).png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >裁判日期</span
                  >
                </template>
                <div class="sift_tree">
                  <el-tree
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    :data="timeall ? timeData : timeData.slice(0, 10)"
                    :props="time"
                    @node-click="timeClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="
                        char_.includes(data.key_as_string + '-01-01') &&
                        char_.includes(data.key_as_string + '-12-31')
                          ? 'color: #e6a23c;'
                          : ''
                      "
                      slot-scope="{ node, data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          node.label
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="timeData.length > 10"
                    @click="times"
                    v-show="timeShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="3">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/4(1)(1).png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px">案由</span>
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="reasonData.slice(0, 10)"
                    :props="reason"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="briefClick"
                    class="region"
                    style="padding-left: 20px"
                  >
                    <span class="custom-tree-node" slot-scope="{ node, data }">
                      <span
                        style="line-height: 20px"
                        :style="
                          char_.includes(data.val) ? 'color: #e6a23c;' : ''
                        "
                        ><span style="font-weight: 900 !important">{{
                          node.label
                        }}</span
                        >({{ data.count }})</span
                      >
                    </span>
                  </el-tree>
                  <span v-if="reasonData.length > 10" style="">查看更多</span>
                </div>
              </el-submenu>
              <el-submenu index="0" v-if="refData.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/00.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >参照级别</span
                  >
                </template>

                <div class="sift_tree">
                  <el-tree
                    :data="refData"
                    :props="ref"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="refClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="char_.includes(data.key) ? 'color: #e6a23c;' : ''"
                      slot-scope="{ data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          data.key
                        }}</span
                        >({{ data.doc_count }})</span
                      >
                    </span>
                  </el-tree>
                </div>
              </el-submenu>
              <el-submenu index="7" v-if="wordData.length > 0">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/25.png"
                    alt=""
                    style="width: 30px; height: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px">关键词</span>
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="wordall ? wordData : wordData.slice(0, 10)"
                    :props="keyWord"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="wordClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="
                        char_.includes(commas_left + data.key + commas_left)
                          ? 'color: #e6a23c;'
                          : ''
                      "
                      slot-scope="{ node, data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          node.label
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="wordData.length > 10"
                    @click="word"
                    v-show="wordShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>

              <el-submenu index="4">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/258.png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >审判程序</span
                  >
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="proall ? proData : proData.slice(0, 10)"
                    :props="trialPro"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="proceduresClick"
                    style="padding-left: 20px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="
                        char_.includes(commas_left + data.key + commas_left)
                          ? 'color: #e6a23c;'
                          : ''
                      "
                      slot-scope="{ node, data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">{{
                          node.label
                        }}</span>
                        ({{ data.doc_count }})</span
                      >
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="proData.length > 10"
                    @click="pro"
                    v-show="proShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
              <el-submenu index="6">
                <template slot="title">
                  <img
                    src="../../../assets/imgs/搜案例(1)/21).png"
                    alt=""
                    style="width: 30px; margin-right: 10px"
                  />
                  <span style="font-weight: 900; font-size: 18px"
                    >文书类型</span
                  >
                </template>
                <div class="sift_tree">
                  <el-tree
                    :data="typeall ? typeData : typeData.slice(0, 10)"
                    :props="docType"
                    v-loading="loadNode"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgb(250, 242, 234)"
                    @node-click="typeClick"
                    style="padding-left: 23px"
                  >
                    <span
                      class="custom-tree-node"
                      :style="char_.includes(data.key) ? 'color: #e6a23c;' : ''"
                      slot-scope="{ node, data }"
                    >
                      <span style="line-height: 20px"
                        ><span style="font-weight: 900 !important">
                          {{ node.label }}</span
                        >
                        ({{ data.doc_count }})</span
                      >
                    </span>
                  </el-tree>
                  <span
                    class="more"
                    v-if="typeData.length > 10"
                    @click="type_"
                    v-show="typeShow"
                    >查看更多</span
                  >
                </div>
              </el-submenu>
            </el-menu>
          </div>
          <div class="box_right">
            <div class="box_right_top">
              <div>
                <span style="margin-right: 20px"
                  >共<span style="color: #cf8700">{{ totalCount }}</span
                  >篇</span
                >
                <el-popover placement="bottom-start" trigger="click">
                  <div class="popovertwo" style="">
                    <h2>
                      您一次最多可以下载Excel 100 篇文书,或者下载Word/Pdf 50
                      篇文书.
                    </h2>
                    <div class="popoverbox">
                      <h2 style="font-weight: 700">将文件导出</h2>
                      <el-radio-group v-model="radio">
                        <el-radio :label="1">当前页面上所有记录</el-radio>
                        <el-radio :label="2"
                          >第<input
                            type="text"
                            v-model="startNumber"
                            nkeyup="value=value.replace(/^(0+)|[^\d]+/g,'')"
                            style="
                              width: 50px;
                              border: 1px solid rgb(221, 218, 218);
                              border-radius: 10px;
                              margin: 0 5px;
                              padding-left: 5px;
                            "
                          />篇&emsp;至&emsp;第<input
                            type="text"
                            v-model="endNumber"
                            style="
                              width: 50px;
                              border: 1px solid rgb(221, 218, 218);
                              border-radius: 10px;
                              margin: 0 5px;
                              padding-left: 5px;
                            "
                          />篇
                        </el-radio>
                      </el-radio-group>
                    </div>

                    <div class="popoverbox">
                      <h2 style="font-weight: 700">文件格式</h2>
                      <el-radio-group v-model="radios">
                        <el-radio :label="3">EXCEL</el-radio>
                        <el-radio :label="4">PDF</el-radio>

                        <el-radio :label="6">WORD</el-radio>
                      </el-radio-group>
                    </div>
                    <div class="popoverbox" v-if="radios == 3">
                      <h2 style="font-weight: 700">下载字段</h2>
                      <el-checkbox-group
                        v-model="checkedCitiesField"
                        @change="handleCheckedCitiesChange"
                      >
                        <el-checkbox
                          v-for="city in cities"
                          :label="city"
                          :key="city"
                          style="margin: 0px; width: 100px"
                          :disabled="
                            city == '序号' || city == '标题' || city == '案号'
                              ? true
                              : false
                          "
                          >{{ city }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                    <div class="export">
                      <el-button
                        type="primary"
                        @click="onDownload"
                        :loading="exportLoading"
                        style="background: rgb(250, 208, 93); color: white"
                        >{{ export_tit }}</el-button
                      >
                    </div>
                  </div>
                  <span
                    style="
                      color: rgb(97, 97, 97);
                      height: 40px;
                      line-height: 40px;
                    "
                    class="batch"
                    slot="reference"
                    ><i class="el-icon-download" style="font-size: 18px"
                      ><span style="font-size: 15px">批量下载</span></i
                    ></span
                  >
                </el-popover>

                <el-radio-group
                  v-model="radio_video"
                  style="margin: 0 0 0 20px"
                >
                  <el-radio :label="'1'" @click.native.prevent="video_sift('1')"
                    >庭审视频</el-radio
                  >
                </el-radio-group>
              </div>

              <div>
                <span style="margin-right: 10px" v-if="sortShow">排序方式</span>
                <el-select
                  v-model="valuesort"
                  placeholder="请选择"
                  v-if="sortShow"
                  size="mini"
                  style="width: 110px"
                  class="bac"
                >
                  <el-option
                    v-for="item in defaultsort"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                    <span @click="itemsort(item.value)">{{ item.label }}</span>
                  </el-option>
                </el-select>
                <el-button-group
                  style="margin-left: 20px"
                  class="types"
                  element-loading-spinner="el-icon-loading"
                >
                  <el-button
                    @click="dataType('chart')"
                    :class="picked ? 'listPick' : 'EChart'"
                    >列表化</el-button
                  >
                  <el-button
                    @click="dataType('list')"
                    :class="picked ? 'EChart' : 'listPick'"
                    >可视化</el-button
                  >
                </el-button-group>
              </div>
            </div>
            <div
              class="box_main"
              :class="exampleList_number > 3 ? 'box_main_' : ''"
              v-loading="loading_box"
              v-if="picked"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="min-height: 500px"
              element-loading-background="rgba(255, 255, 255, 0.5)"
            >
              <div
                v-if="exampleList_number == 0"
                style="
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  height: 500px;
                "
              >
                <div>
                  <img src="./kongkong.png" alt="" />
                  <div style="text-align: center; font-size: 20px">
                    暂无数据
                  </div>
                </div>
              </div>
              <div
                class="box_main_list"
                v-for="(item, index) in exampleList"
                :key="index"
              >
                <div class="title">
                  <router-link
                    :to="{
                      path: `/detail/${item._id}`,
                      query: { keyword: input, type: radio01 },
                    }"
                    target="_blank"
                    style="width: calc(100% - 270px)"
                  >
                    <h2
                      style="
                        display: inline-block;
                        font-weight: 900;
                        font-size: 18px;
                      "
                      v-html="item._source.Casename"
                    ></h2>
                  </router-link>
                  <div style="" class="collDown">
                    <div
                      style="margin: 2px 10px 0 0; color: #e6a23c"
                      v-if="item.score"
                    >
                      案件相似度：{{ item.score }}
                    </div>
                    <div style="margin: 0px 10px 0 0; color: #e6a23c">
                      <el-tooltip
                        content="类案检索"
                        placement="bottom"
                        effect="light"
                        v-if="item._source.fact"
                        popper-class="tip-class"
                      >
                        <img
                          src="../../../assets/imgs/leianjiansuo_o.png"
                          alt=""
                          style="width: 35px; cursor: pointer"
                          @click="detailSearch(item._source.fact)"
                        />
                      </el-tooltip>
                    </div>
                    <div class="collection" v-if="!item._source.coll">
                      <el-tooltip
                        content="收藏"
                        placement="bottom"
                        effect="light"
                        popper-class="tip-class"
                      >
                        <img
                          @click="collectible(item)"
                          src="../../../assets/imgs/2.0/_收藏.png"
                          alt=""
                        />
                      </el-tooltip>
                    </div>
                    <div class="collection" v-if="item._source.coll">
                      <el-tooltip
                        content="收藏"
                        placement="left"
                        effect="light"
                        popper-class="tip-class"
                      >
                        <img
                          v-if="item._source.coll == 0"
                          @click="collectible(item)"
                          src="../../../assets/imgs/2.0/_收藏.png"
                          alt=""
                        />
                      </el-tooltip>
                      <el-popconfirm
                        title="确认取消收藏吗？"
                        @confirm="cancel(item)"
                      >
                        <img
                          slot="reference"
                          v-if="item._source.coll == 1"
                          src="../../../assets/imgs/2.0/收藏3.png"
                          alt=""
                        />
                      </el-popconfirm>
                    </div>
                    <el-dropdown style="height: 28px; margin: 0 10px">
                      <el-button
                        type="warning"
                        icon="el-icon-download"
                        circle
                        size="mini"
                      ></el-button>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item
                          ><span @click="pdfDown(item._id)"
                            ><img
                              class="down_icon"
                              src="../../../assets/imgs/图标/pdf (1).png"
                              alt=""
                            />
                            PDF文件</span
                          ></el-dropdown-item
                        >
                        <el-dropdown-item
                          ><span @click="wordDown(item._id)"
                            ><img
                              class="down_icon"
                              src="../../../assets/imgs/图标/word.png"
                              alt=""
                            />
                            WORD文件</span
                          ></el-dropdown-item
                        >
                      </el-dropdown-menu>
                    </el-dropdown>
                  </div>
                </div>
                <div>
                  <span
                    v-if="
                      item._source.Ref_level &&
                      item._source.Ref_level.length > 0
                    "
                    ><el-tag
                      v-for="(item_eef, index) in item._source.Ref_level"
                      :key="index"
                      type="warning"
                      style="margin: 10px"
                      >{{ item_eef }}</el-tag
                    ></span
                  >
                  <span
                    v-if="
                      item._source.Cause_Reason_Word &&
                      item._source.Cause_Reason_Word.length > 0
                    "
                    ><el-tag
                      v-for="(item_cause, index) in item._source
                        .Cause_Reason_Word"
                      :key="index"
                      style="margin: 10px"
                      type="warning"
                      >{{ item_cause }}</el-tag
                    ></span
                  >
                  <span
                    v-if="item._source.TrialPro && item._source.TrialPro !== ''"
                    ><el-tag style="margin: 10px" type="warning">{{
                      item._source.TrialPro
                    }}</el-tag></span
                  >
                </div>

                <div class="box_detail">
                  <router-link
                    :to="{
                      path: `/detail/${item._id}`,
                      query: { keyword: input, type: radio01 },
                    }"
                    target="_blank"
                    v-if="item._source.Trial"
                  >
                    <img
                      src="../../../assets/imgs/u50.png"
                      class="video_img"
                      alt=""
                    />
                  </router-link>

                  <div class="basic">
                    <div class="basic_left">
                      <div class="align_left">
                        <i
                          class="el-icon-tickets"
                          style="margin-right: 5px"
                        ></i>
                        <h2 style="display: inline-block">基本信息</h2>
                      </div>
                    </div>
                    <div class="basic_right">
                      <div
                        style="
                          font-size: 14px;
                          display: flex;
                          justify-content: space-between;
                        "
                      >
                        <div class="basic_content">
                          <div>
                            审理法院：<span
                              v-if="item._source.Court"
                              v-html="item._source.Court.name"
                              style="width: 200px; display: inline"
                            >
                            </span>
                          </div>
                          <div>
                            案&emsp;&emsp;号：<span
                              v-if="item._source.CaseId"
                              v-html="item._source.CaseId"
                            ></span>
                          </div>
                        </div>
                        <div class="basic_content">
                          <div>
                            裁判日期：<span
                              v-if="item._source.RefereeDate"
                              v-html="item._source.RefereeDate"
                            ></span>
                          </div>
                          <div style="max-width: 300px; display: flex">
                            <span style="min-width: 71px; display: inline-block"
                              >案&emsp;&emsp;由：</span
                            >
                            <div v-if="item._source.Cause_Reason_Word">
                              <span
                                v-for="(item, index_sour) in item._source
                                  .Cause_Reason_Word"
                                :key="index_sour"
                                ><span style="margin-right: 5px">{{
                                  item
                                }}</span></span
                              >
                            </div>
                          </div>
                        </div>
                      </div>
                      <p
                        class="key_txt"
                        style="font-size: 14px; line-height: 30px"
                        v-if="
                          item._source.Keyword &&
                          item._source.Keyword.length > 0
                        "
                      >
                        <span class="key_tit">关&ensp;键&ensp;词：</span>
                        <span class="key_box"
                          ><span
                            v-for="(item_key, index) in item._source.Keyword"
                            :key="index"
                            ><span v-html="item_key"></span
                            ><span
                              v-if="index < item._source.Keyword.length - 1"
                            >
                              ;
                            </span></span
                          >
                        </span>
                      </p>
                    </div>
                  </div>

                  <div
                    v-if="
                      or &&
                      item._source.retrieval &&
                      item._source.retrieval.par.length > 0
                    "
                  >
                    【命中频次】：<el-tag
                      type="success"
                      v-if="item._source.retrieval.word_times"
                      >{{ item._source.retrieval.word_times.word[0] }}
                      <span v-if="item._source.retrieval.word_times"
                        >&emsp;{{
                          item._source.retrieval.word_times.times
                        }}</span
                      ></el-tag
                    >
                  </div>

                  <div
                    class="card"
                    v-if="
                      item._source.retrieval ||
                      item._source.reason ||
                      item._source.result
                    "
                  >
                    <el-tabs
                      type="border-card"
                      v-if="
                        item._source.retrieval.word_times ||
                        item._source.reason !== '' ||
                        item._source.result !== ''
                      "
                    >
                      <el-tab-pane
                        v-if="item._source.retrieval.word_times"
                        label="命中结果"
                      >
                        <div v-if="one !== index">
                          <div
                            v-for="(
                              items, index
                            ) in item._source.retrieval.par.slice(0, 5)"
                            :key="index + '04'"
                          >
                            <div
                              class="hits"
                              v-for="(value, key) in items"
                              :key="key + '01'"
                            >
                              <span style="color: #7aafff">【{{ key }}】</span
                              >:<span
                                style="width: 800px"
                                v-html="value"
                              ></span>
                            </div>
                          </div>
                        </div>
                        <div v-if="one == index">
                          <div
                            v-for="(items, index) in item._source.retrieval.par"
                            :key="index + '02'"
                          >
                            <div
                              class="hits"
                              v-for="(value, key) in items"
                              :key="key + '03'"
                            >
                              <span style="color: #7aafff">【{{ key }}】</span
                              >:<span
                                style="width: 800px"
                                v-html="value"
                              ></span>
                            </div>
                          </div>
                        </div>

                        <div
                          class="mores"
                          v-if="
                            item._source.retrieval.par.length > 4 &&
                            one !== index
                          "
                          @click="greater(index)"
                        >
                          <span>查看更多 > ></span>
                        </div>
                        <div class="mores01">
                          <router-link
                            :to="{
                              path: `/detail/${item._id}`,
                              query: { keyword: input, type: radio01 },
                            }"
                            target="_blank"
                          >
                            <span>更多请查看原文</span>
                          </router-link>
                        </div>
                      </el-tab-pane>
                      <el-tab-pane
                        label="本院认为"
                        :key="item._source.reason"
                        v-if="item._source.reason !== ''"
                        ><p>{{ item._source.reason }}</p></el-tab-pane
                      >
                      <el-tab-pane
                        label="裁判结果"
                        :key="item._source.result"
                        v-if="item._source.result !== ''"
                        ><p>{{ item._source.result }}</p></el-tab-pane
                      >
                    </el-tabs>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="ECharts_main"
              v-loading="loadNode"
              element-loading-text="拼命加载中"
              element-loading-spinner="el-icon-loading"
              style="min-height: 500px"
              element-loading-background="rgba(255, 255, 255, 0.5)"
              v-if="!picked"
            >
              <CHART
                :eChars="leftData"
                v-loading="loadNode"
                v-if="update"
                @transfer="getUser"
              ></CHART>
            </div>

            <div class="page-bar" v-if="all > 1 && picked">
              <ul>
                <li v-if="cur > 1">
                  <a v-on:click="cur--, pageClick()">上一页</a>
                </li>
                <li v-if="cur == 1"><a class="banclick">上一页</a></li>
                <li
                  v-for="index in indexs"
                  :key="index"
                  v-bind:class="{ active: cur == index }"
                >
                  <a v-on:click="btnClick(index)">{{ index }}</a>
                </li>
                <li v-if="cur != all">
                  <a v-on:click="pageClick(cur++)">下一页</a>
                </li>
                <li v-if="cur == all"><a class="banclick">下一页</a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <ComFooter></ComFooter>
    </div>
  </div>
</template>

<script>
import store from "@/store";

import "echarts-wordcloud/dist/echarts-wordcloud";
import "echarts-wordcloud/dist/echarts-wordcloud.min";

import CHART from "./component/charts.vue";
import WORD from "./component/word.vue";
import ComFooter from "../../../components/ComFooter.vue";
const cityOptions = [
  "序号",
  "标题",
  "案号",
  "案由",
  "审理程序",
  "案件类型",
  "文书类型",
  "法院",
  "审判长",
  "审判日期",
  "裁判理由",
  "裁判结果",
  "原告",
  "被告",
  "第三人",
  "律师",
  "律所",
];
export default {
  inject: ["reload"],
  props: ["eChars"],
  data() {
    return {
      update: true,

      input: "",
      params: {},

      search: {},
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页展示几条
      totalCount: null, //总条数
      form: {
        search: "",
        order: "",
        page: 1,
        pageSize: 10,
      },

      options: [
        //刑罚
        {
          value: "管制",
          label: "管制",
        },
        {
          value: "拘役",
          label: "拘役",
        },
        {
          value: "有期徒刑",
          label: "有期徒刑",
        },
        {
          value: "无期徒刑",
          label: "无期徒刑",
        },
        {
          value: "死刑",
          label: "死刑",
        },
        {
          value: "附加刑",
          label: "附加刑",
        },
      ],

      refLevel: "", //参照级别
      valuecourtLevel: "", //法院级别
      valuepaperwork: "", //文书类型
      valueoptions: "", //刑罚
      valuetrialtype: "", //审判程序
      valuereference: "", //参照级别
      paperworkType: "", //关键词
      radio: 1,
      radios: 3,

      statistics: null,
      exampleList: null,
      exampleList_number: null,
      visible: false,
      loadNode: true,
      refData: [],
      levalData: [],
      courtData: [],
      reasonData: [],
      proData: [],
      timeData: [],
      typeData: [],
      wordData: [],
      ref: {
        children: "children",
        label: "key",
      },
      leval: {
        children: "children",
        label: "key",
      },
      court: {
        children: "children",
        label: "name",
      },
      reason: {
        children: "children",
        label: "name",
      },
      trialPro: {
        children: "children",
        label: "key",
      },
      time: {
        children: "children",
        label: "key_as_string",
      },
      docType: {
        children: "children",
        label: "key",
      },
      keyWord: {
        children: "children",
        label: "key",
      },

      isIndeterminate: false,
      checkAll: false,
      isIndeterminate: true,
      condition: [], //条件列表

      loading_box: true,
      defaultsort: [
        {
          value: "",
          label: "相关度",
        },
        {
          value: "asc",
          label: "↑ 裁判日期",
        },
        {
          value: "desc",
          label: "↓ 裁判日期",
        },
      ],
      valuesort: "desc",
      sort: "desc",
      startNumber: "",
      endNumber: "",
      fromnumber: "",
      check: false,
      aa: null,
      defaultall: false,
      openeds: ["0", "1", "2", "3", "4", "5", "6", "7"],
      // checkedCities:null,
      moreall: false,
      moreShow: true,
      proall: false,
      proShow: true,
      timeall: false,
      timeShow: true,
      wordall: false,
      wordShow: true,
      advanceds: [],

      typeall: false,
      typeShow: true,

      all: 1, //总页数
      cur: 1, //当前页码

      briefData: [],
      picked: true,
      leftData: "",
      // hits_word: "",
      or: false,
      one: null,
      search_type: "",
      sortShow: true,
      briefSelect: [],
      searchInput: [],
      checkedCitiesField: [
        "序号",
        "标题",
        "案号",
        "案由",
        "审理程序",
        "案件类型",
        "文书类型",
        "法院",
        "审判长",
        "审判日期",
        "裁判理由",
        "裁判结果",
        "原告",
        "被告",
        "第三人",
        "律师",
        "律所",
      ],
      cities: cityOptions,
      ranking: [],
      file: [],
      select: "Content",
      fieldDate: "RefereeDate",
      pickWord: "",
      radio01: "2",
      activeName: "first",
      wordsEchaets: [],
      casetype_txt: "",
      fee_: "",
      char_: "",
      show_: true,
      commas_left: '"',
      radio_video: "",
      exportLoading: false,
      export_tit: "开始导出",
    };
  },
  computed: {
    indexs: function () {
      var left = 1;
      var right = this.all;
      var ar = [];
      if (this.all >= 10) {
        if (this.cur > 6 && this.cur < this.all - 2) {
          left = this.cur - 6;
          right = this.cur + 3;
        } else {
          if (this.cur <= 6) {
            left = 1;
            right = 10;
          } else {
            right = this.all;
            left = this.all - 4;
          }
        }
      }
      while (left <= right) {
        ar.push(left);
        left++;
      }
      return ar;
    },
  },
  created() {
    // if (this.$route.query.condition) {
    //   console.log("a");
    //   this.char_ = this.$route.query.condition;
    //   this.condition = JSON.parse(this.$route.query.condition);
    // } else {
    if (window.localStorage.getItem("search_new")) {
      this.char_ = window.localStorage.getItem("search_new");
    }
    if (window.localStorage.getItem("searchType")) {
      this.radio01 = window.localStorage.getItem("searchType");
      // console.log(this.radio01);
      this.fieldDate = "";
      this.valuesort = "";
      // this.accuracy();
    }
    console.log("a");
    // console.log(JSON.parse(window.localStorage.getItem("search_new")));
    if (window.localStorage.getItem("search_new")) {
      this.condition = JSON.parse(window.localStorage.getItem("search_new"));
    }
    // }

    this.caseList();

    this.leftList();

    this.value = this.options[0].value;
  },
  methods: {
    truncateString(str, maxLength) {
      if (str.length <= maxLength) {
        return str; // 字符串长度小于等于最大长度，不需要截取
      } else {
        return str.substring(0, maxLength) + "..."; // 截取前面最多maxLength个字符并添加省略号
      }
    },
    handleClose_s(type) {
      // console.log(type);
      let condition_copy = [];
      this.condition.forEach((item, index) => {
        if (item[1] !== type) {
          condition_copy.push(item);
        }
      });
      this.condition = condition_copy;
      // console.log(this.condition);
      this.Flushed();
    },
    Frequency_(val) {
      let i = [];
      this.condition.forEach((item, index) => {
        if (item[1] == val) {
          i.push(index);
        }
      });
      // console.log(i);
      return i[0];
    },
    Frequency(val) {
      let times = 0;
      // console.log(this.condition);
      this.condition.forEach((item, index) => {
        // console.log(item);
        // return
        if (item[1] == val) {
          times++;
        }
      });

      return times;
    },
    reload_() {
      this.show_ = false;
      this.$nextTick(function () {
        this.show_ = true;
      });
    },
    // 刷选刷新
    Flushed() {
      window.localStorage.setItem("search_new", JSON.stringify(this.condition));
      this.cur = 1;

      this.caseList();
      this.leftList();
      this.char_ = window.localStorage.getItem("search_new");
      this.reload_();
    },
    // excel下载字段
    handleCheckedCitiesChange(value) {
      // console.log(value);
      this.checkedCitiesField = value;
    },
    //   数据初始化
    caseList() {
      window.scrollTo(0, 0);

      this.loading_box = true;
      if (window.localStorage.getItem("search_new")) {
        this.form.search = window.localStorage.getItem("search_new");
      } else {
        this.form.search = "[]";
      }

      this.form.page = this.cur;
      this.form.order = JSON.stringify({
        field: this.fieldDate,
        type: this.sort,
      });
      this.$http
        .post("/search", this.form)
        .then((res) => {
          if (res.data.code == 200) {
            this.exampleList = res.data.data.list.hits;

            this.exampleList.forEach((item, index) => {
              if (item._source.retrieval.par.length > 0) {
                let aa = 0;

                item._source.retrieval.par.forEach((num) => {
                  let string = Object.values(num)[0];
                  string = string.replace(/<[^>]+>/g, "");
                  let numberes =
                    string.split(item._source.retrieval.word_times.word[0])
                      .length - 1;

                  aa = aa + numberes;
                });

                this.exampleList[index]._source.retrieval.word_times.num = aa;
              }
            });

            this.exampleList_number = this.exampleList.length;

            this.checkedCities = res.data.data.list.hits;

            this.totalCount = res.data.data.list.total.value;

            if (Math.ceil(this.totalCount / 10) > 1000) {
              this.all = 1000;
            }
            if (Math.ceil(this.totalCount / 10) <= 1000) {
              this.all = Math.ceil(this.totalCount / 10);
            }

            this.sortShow = true;
          }

          this.loading_box = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    leftList() {
      window.scrollTo(0, 0);
      this.loadNode = true;
      // this.form.search = window.localStorage.getItem("search_new");
      if (window.localStorage.getItem("search_new")) {
        this.form.search = window.localStorage.getItem("search_new");
      } else {
        this.form.search = "[]";
      }
      this.form.page = this.cur;
      this.form.order = JSON.stringify({
        field: this.fieldDate,
        type: this.sort,
      });
      let form_ = {
        search: "[]",
        order: this.form.order,
        page: 1,
        pageSize: 10,
      };
      this.$http
        .post("/category", this.form)
        .then((res) => {
          this.loadNode = false;

          this.leftData = res.data.data.category;
          this.reloads();
          this.statistics = res.data.data.category;

          this.refData = res.data.data.category.Ref_level.filter(item => item.key !== '');
          this.levalData = res.data.data.category.Leval.filter(item => item.key !== '');
          this.courtData = res.data.data.category.court.filter(item => item.name !== '');
          this.reasonData = res.data.data.category.reason.filter(item => item.name !== '');
          this.proData = res.data.data.category.TrialPro.filter(item => item.key !== '');
          this.timeData = res.data.data.category.Time.filter(item => item.key !== '');

          this.typeData = res.data.data.category.DocType.filter(item => item.key !== '');
          this.wordData = res.data.data.category.Keyword.filter(item => item.key !== '');

          this.wordsEchaets = [];
          this.wordData.forEach((item) => {
            let word = {
              name: item.key,
              value: item.doc_count,
            };
            this.wordsEchaets.push(word);
          });

          let parameter = { ...this.form };
          window.localStorage.setItem("parameter", JSON.stringify(parameter));
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 案由分类
    visibles() {
      this.$http
        .get("/ay", {})
        .then((res) => {
          this.briefData = res.data.data;

          this.briefSelect = [];
          this.briefData.forEach((item) => {
            let briefOne = {
              value: item.val,
              label: item.name,
            };
            this.briefSelect.push(briefOne);
            if (item.children.length > 0) {
              item.children.forEach((itemTwo) => {
                let briefTwo = {
                  value: itemTwo.val,
                  label: itemTwo.name,
                };
                this.briefSelect.push(briefTwo);
                if (itemTwo.children.length > 0) {
                  itemTwo.children.forEach((itemThree) => {
                    let briefThree = {
                      value: itemThree.val,
                      label: itemThree.name,
                    };
                    this.briefSelect.push(briefThree);
                    if (itemThree.children.length > 0) {
                      itemThree.children.forEach((itemFour) => {
                        let briefFour = {
                          value: itemFour.val,
                          label: itemFour.name,
                        };
                        this.briefSelect.push(briefFour);
                      });
                    }
                  });
                }
              });
            }
          });
          // console.log(this.briefSelect);
        })
        .catch((err) => {});
    },
    detailSearch(val) {
      // this.condition = [["case_description", [["and", val, this.radio01]]]];
      // this.Flushed();

      // let routeData = this.$router.resolve({
      //   name: "Case",
      //   //  params: { loanOrderId, userId }
      // });
      // // window.sessionStorage.setItem("new_search",'a');
      // window.open(routeData.href, "_blank");

      // this.$router
      //   .push({
      //     path: "/case",
      //     query: { condition: JSON.stringify(this.condition) },
      //   })
      //   .catch(() => {});

      let condition_ = [["case_description", [["and", val, this.radio01]]]];
      let routeData = this.$router.resolve({
        path: "/case_condition",
        query: { condition: JSON.stringify(condition_) },
      });
      // let urlWithQueryParams =
      //   routeData.href +
      //   "?condition=" +
      //   encodeURIComponent(JSON.stringify(condition_));
      // console.log(routeData.href)
      // return
      window.open(routeData.href, "_blank");
    },
    newSearch() {
      if (this.input !== "") {
        if (this.select == "case_description") {
          if (this.input.length < 50) {
            this.$message({
              message: "案情描述不能不小于50字!请补充描述",
              type: "warning",
            });
            return;
          }
        } else {
          let a =
            /\d{4}〕.*?号之[一|二|三|四|五|六|七|八|九|十]$|〔\d{4}〕.*?号$|\（\d{4}\）.*?号之[一|二|三|四|五|六|七|八|九|十]$|\(\d{4}\).*?号之[一|二|三|四|五|六|七|八|九|十]$|\（\d{4}\）.*?号之.*?[一|二|三|四|五|六|七|八|九|十]$|\(\d{4}\).*?号之.*?[一|二|三|四|五|六|七|八|九|十]$|\(\d{4}\).*?号$|\（\d{4}\）.*?号$|(\[d{4}\]).*?号$/;
          if (a.test(this.input)) {
            this.select = "CaseId";
          }
        }

        this.condition = [[this.select, [["and", this.input, this.radio01]]]];
        this.Flushed();
      } else {
        this.$message({
          showClose: true,
          message: "请输入检索内容!",
          type: "warning",
        });
      }
    },
    video_sift(e) {
      // e为radio的label值

      e === this.radio_video ? (this.radio_video = "") : (this.radio_video = e);
      console.log(this.radio_video);

      if (!this.char_.includes("Trial")) {
        let video = ["Trial", true];
        this.condition.push(video);
        this.Flushed();
      } else {
        let sea = JSON.parse(window.localStorage.getItem("search_new"));
        sea.forEach((item, index) => {
          if (item[0] == "Trial") {
            if (this.radio_video !== "") {
              item[1] = true;
            } else {
              item[1] = false;
            }
          }
        });
        this.condition = sea;
        this.Flushed();
      }
    },

    // 高级导出
    onDownload() {
      this.exportLoading = true;
      this.export_tit = "导出中...";
      if (this.radios == 3) {
        this.ranking = [];

        this.checkedCitiesField.forEach((item) => {
          if (item == "序号") {
            let ranks = {
              field: item,
              rank: 1,
            };
            this.ranking.push(ranks);
          }
          if (item == "标题") {
            let ranks = {
              field: item,
              rank: 2,
            };
            this.ranking.push(ranks);
          }
          if (item == "案号") {
            let ranks = {
              field: item,
              rank: 3,
            };
            this.ranking.push(ranks);
          }
          if (item == "案由") {
            let ranks = {
              field: item,
              rank: 4,
            };
            this.ranking.push(ranks);
          }
          if (item == "审理程序") {
            let ranks = {
              field: item,
              rank: 5,
            };
            this.ranking.push(ranks);
          }
          if (item == "案件类型") {
            let ranks = {
              field: item,
              rank: 6,
            };
            this.ranking.push(ranks);
          }
          if (item == "文书类型") {
            let ranks = {
              field: item,
              rank: 7,
            };
            this.ranking.push(ranks);
          }
          if (item == "法院") {
            let ranks = {
              field: item,
              rank: 8,
            };
            this.ranking.push(ranks);
          }
          if (item == "审判长") {
            let ranks = {
              field: item,
              rank: 9,
            };
            this.ranking.push(ranks);
          }
          if (item == "审判日期") {
            let ranks = {
              field: item,
              rank: 10,
            };
            this.ranking.push(ranks);
          }
          if (item == "裁判理由") {
            let ranks = {
              field: item,
              rank: 11,
            };
            this.ranking.push(ranks);
          }
          if (item == "裁判结果") {
            let ranks = {
              field: item,
              rank: 12,
            };
            this.ranking.push(ranks);
          }
          if (item == "原告") {
            let ranks = {
              field: item,
              rank: 13,
            };
            this.ranking.push(ranks);
          }
          if (item == "被告") {
            let ranks = {
              field: item,
              rank: 14,
            };
            this.ranking.push(ranks);
          }
          if (item == "第三人") {
            let ranks = {
              field: item,
              rank: 15,
            };
            this.ranking.push(ranks);
          }
          if (item == "律师") {
            let ranks = {
              field: item,
              rank: 16,
            };
            this.ranking.push(ranks);
          }
          if (item == "律所") {
            let ranks = {
              field: item,
              rank: 17,
            };
            this.ranking.push(ranks);
          }
        });

        this.ranking.sort(
          (firstItem, secondItem) => firstItem.rank - secondItem.rank
        );

        this.file = [];
        this.ranking.forEach((item) => {
          this.file.push(item.field);
        });
      }
      if (this.radios == 3) {
        if (this.radio == 1) {
          // console.log(typeof this.cur)
          var numbers = 10;
          var fromnumber = (this.cur - 1) * 10;
          // console.log(numbers  , fromnumber)
          this.$http
            .post("/excel", {
              from: fromnumber,
              size: numbers,
              search: window.localStorage.getItem("search_new"),
              order: JSON.stringify({
                field: this.fieldDate,
                type: this.sort,
              }),
              file: JSON.stringify({ file: this.file }),
            })
            .then((res) => {
              if (res.data.code == 200) {
                window.location.href = res.data.data.url;
              }
              this.exportLoading = false;
              this.export_tit = "开始导出";
            })
            .catch((error) => {
              console.log(error);
              this.exportLoading = false;
              this.export_tit = "开始导出";
            });
        }
        if (this.radio == 2) {
          if (this.endNumber - this.startNumber >= 100) {
            this.$message({
              message: "您一次最多可以下载Excel 100 篇文书",
              type: "warning",
            });
            this.exportLoading = false;
            this.export_tit = "开始导出";
          } else {
            if (this.endNumber !== "" && this.startNumber !== "") {
              var numbers = Number(this.endNumber);
              var fromnumber = (this.cur - 1) * 10 + Number(this.startNumber);

              this.$http
                .post("/excel", {
                  from: fromnumber,
                  size: numbers,
                  search: window.localStorage.getItem("search_new"),
                  order: JSON.stringify({
                    field: this.fieldDate,
                    type: this.sort,
                  }),
                  file: JSON.stringify({ file: this.file }),
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    window.location.href = res.data.data.url;
                  }
                  this.exportLoading = false;
                  this.export_tit = "开始导出";
                })
                .catch((error) => {
                  console.log(error);
                  this.exportLoading = false;
                  this.export_tit = "开始导出";
                });
            } else {
              this.$message({
                message: "请输入正整数",
                type: "warning",
              });
            }
          }
        }
      }
      if (this.radios == 4) {
        if (this.radio == 1) {
          var numbers = 10;
          var fromnumber = (this.cur - 1) * 10;
          this.$http
            .post("/pdfs", {
              from: fromnumber.toString(),
              size: numbers.toString(),
              search: window.localStorage.getItem("search_new"),
              order: JSON.stringify({
                field: this.fieldDate,
                type: this.sort,
              }),
            })
            .then((res) => {
              if (res.data.code == 200) {
                window.location.href = res.data.data.url;
              }
              this.exportLoading = false;
              this.export_tit = "开始导出";
            })
            .catch((error) => {
              console.log(error);
              this.exportLoading = false;
              this.export_tit = "开始导出";
            });
        }
        if (this.radio == 2) {
          if (this.endNumber - this.startNumber >= 50) {
            this.$message({
              message: "您一次最多可以下载Pdf 50 篇文书",
              type: "warning",
            });
            this.exportLoading = false;
            this.export_tit = "开始导出";
          } else {
            if (this.endNumber !== "" && this.startNumber !== "") {
              var numbers = Number(this.endNumber);
              var fromnumber = (this.cur - 1) * 10 + Number(this.startNumber);
              this.$http
                .post("/pdfs", {
                  from: fromnumber.toString(),
                  size: numbers.toString(),
                  search: window.localStorage.getItem("search_new"),
                  order: JSON.stringify({
                    field: this.fieldDate,
                    type: this.sort,
                  }),
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    window.location.href = res.data.data.url;
                  }
                  this.exportLoading = false;
                  this.export_tit = "开始导出";
                })
                .catch((error) => {
                  console.log(error);
                  this.exportLoading = false;
                  this.export_tit = "开始导出";
                });
            } else {
              this.$message({
                message: "请输入正整数",
                type: "warning",
              });
            }
          }
        }
      }

      if (this.radios == 6) {
        if (this.radio == 1) {
          var numbers = 10;
          var fromnumber = (this.cur - 1) * 10;
          this.$http
            .post("/words", {
              from: fromnumber.toString(),
              size: numbers.toString(),
              search: window.localStorage.getItem("search_new"),
              order: JSON.stringify({
                field: this.fieldDate,
                type: this.sort,
              }),
            })
            .then((res) => {
              if (res.data.code == 200) {
                window.location.href = res.data.data.url;
              }
              this.exportLoading = false;
              this.export_tit = "开始导出";
            })
            .catch((error) => {
              console.log(error);
              this.exportLoading = false;
              this.export_tit = "开始导出";
            });
        }
        if (this.radio == 2) {
          if (this.endNumber - this.startNumber >= 50) {
            this.$message({
              message: "您一次最多可以下载Word 50 篇文书",
              type: "warning",
            });
            this.exportLoading = false;
            this.export_tit = "开始导出";
          } else {
            if (this.endNumber !== "" && this.startNumber !== "") {
              var numbers = Number(this.endNumber);
              var fromnumber = (this.cur - 1) * 10 + Number(this.startNumber);
              this.$http
                .post("/words", {
                  from: fromnumber.toString(),
                  size: numbers.toString(),
                  search: window.localStorage.getItem("search_new"),
                  order: JSON.stringify({
                    field: this.fieldDate,
                    type: this.sort,
                  }),
                })
                .then((res) => {
                  if (res.data.code == 200) {
                    window.location.href = res.data.data.url;
                    this.exportLoading = false;
                    this.export_tit = "开始导出";
                    es.data.data.url;
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.exportLoading = false;
                  this.export_tit = "开始导出";
                });
            } else {
              this.$message({
                message: "请输入正整数",
                type: "warning",
              });
            }
          }
        }
      }
    },
    itemsort(a) {
      // console.log(a);
      if (a == "") {
        this.fieldDate = "";
      } else {
        this.fieldDate = "RefereeDate";
      }

      this.sort = a;
      this.valuesort = a;
      window.localStorage.setItem("sortType", a);
      this.caseList();
    },

    handleClose(type, index) {
      // console.log(type, index);

      this.condition.splice(index, 1);
      this.Flushed();
      // window.localStorage.setItem("search_new", JSON.stringify(this.condition));
      // this.cur = 1;
      // this.caseList();
      // this.leftList();
      // this.condition = condition;
    },
    handleClose_one(type, i) {
      this.condition.forEach((item, index) => {
        if (item[0] == type) {
          item[1].splice(i, 1);
        }
      });
      this.Flushed();
    },
    handleClose_work(arr, word, i) {
      // console.log(this.condition);
      // console.log(arr, word, i);

      this.condition.forEach((item, index) => {
        if (item.type == "word") {
          arr.splice(i, 1);
          item.name = arr;
          // console.log(arr, i);
          if (arr.length > 0) {
            this.paperworkType = JSON.stringify(item.name);

            this.condition[index] = {
              name: item.name,
              type: "word",
            };
            window.localStorage.setItem(
              "searchinput",
              JSON.stringify(this.condition)
            );
            this.cur = 1;
            this.caseList();
            this.leftList();
          } else {
            this.handleClose(item.type, index);
          }
        }
      });
    },

    // 清空条件
    remove() {
      this.condition = [];

      window.localStorage.setItem("search_new", "[]");
      this.fieldDate = "RefereeDate";
      this.valuesort = "desc";
      this.sort = "desc";
      this.loadNode = true;
      this.loading_box = true;
      this.cur = 1;
      this.Flushed();
      return;
      this.caseList();
      this.leftList();
    },
    // 左侧筛选
    // 参考级别
    refClick(data) {
      // console.log(data);
      // Ref_level
      if (!this.char_.includes(data.key)) {
        // let ref = ["and", "Ref_level", data.key];
        // this.condition.push(ref);
        if (!this.char_.includes("Ref_level")) {
          this.condition.push(["Ref_level", [data.key]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "Ref_level") {
              item[1].push(data.key);
            }
          });
        }

        this.Flushed();
      }
    },
    // 法院级别
    courtClick(data) {
      // Leval
      // console.log(this.char_.includes(data.key));
      if (!this.char_.includes(data.key)) {
        // let court = ["and", "Leval", data.key];
        // this.condition.push(court);
        if (!this.char_.includes("Leval")) {
          this.condition.push(["Leval", [data.key]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "Leval") {
              item[1].push(data.key);
            }
          });
        }

        this.Flushed();
      }
    },
    // 地区
    regionClick(data) {
      // Court
      if (
        !this.char_.includes(this.commas_left + data.name + this.commas_left)
      ) {
        // let region = ["and", "Court", data.name];
        // this.condition.push(region);
        if (!this.char_.includes("Court")) {
          this.condition.push(["Court", [data.name]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "Court") {
              item[1].push(data.name);
            }
          });
        }

        this.Flushed();
      }
    },
    // 案由
    briefClick(data) {
      if (!this.char_.includes(data.val)) {
        // let brief = ["and", "Reason", data.val];
        // this.condition.push(brief);
        if (!this.char_.includes("Reason")) {
          this.condition.push(["Reason", [data.val]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "Reason") {
              item[1].push(data.val);
            }
          });
        }

        this.Flushed();
      }
    },
    // 审判程序
    proceduresClick(data) {
      // console.log(data);
      // TrialPro
      if (
        !this.char_.includes(this.commas_left + data.key + this.commas_left)
      ) {
        // let procedures = ["and", "TrialPro", data.key];
        // this.condition.push(procedures);
        if (!this.char_.includes("Reason")) {
          this.condition.push(["TrialPro", [data.key]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "TrialPro") {
              item[1].push(data.key);
            }
          });
        }

        this.Flushed();
      }
    },
    // 审判时间
    timeClick(data) {
      // RefereeDate
      let start = data.key_as_string + "-01-01";

      let end = data.key_as_string + "-12-31";
      if (!this.char_.includes(start) && !this.char_.includes(end)) {
        // let time = ["and", "RefereeDate", [start, end]];
        // this.condition.push(time);
        if (!this.char_.includes("RefereeDate")) {
          this.condition.push(["RefereeDate", [[start, end]]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "RefereeDate") {
              item[1].push([start, end]);
            }
          });
        }

        this.Flushed();
      }
    },
    // 文书类型
    typeClick(data) {
      // DocType
      if (!this.char_.includes(data.key)) {
        // let time = ["and", "DocType", data.key];
        // this.condition.push(time);
        if (!this.char_.includes("DocType")) {
          this.condition.push(["DocType", [data.key]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "DocType") {
              item[1].push(data.key);
            }
          });
        }

        this.Flushed();
      }
    },
    // 关键词
    wordClick(data) {
      // Keyword
      if (
        !this.char_.includes(this.commas_left + data.key + this.commas_left)
      ) {
        // let word = ["and", "Keyword", [data.key]];
        // this.condition.push(word);
        if (!this.char_.includes("Keyword")) {
          this.condition.push(["Keyword", [data.key]]);
        } else {
          this.condition.forEach((item, index) => {
            if (item[0] == "Keyword") {
              item[1].push(data.key);
            }
          });
        }

        this.Flushed();
      }
    },
    testData(data) {
      // console.log(data);
      this.wordClick(data);
    },
    // 查看更多
    more() {
      this.moreall = true;
      this.moreShow = false;
    },
    word() {
      this.wordall = true;
      this.wordShow = false;
    },
    times() {
      this.timeall = true;
      this.timeShow = false;
    },
    pro() {
      this.proall = true;
      this.proShow = false;
    },
    type_() {
      this.typeall = true;
      this.typeShow = false;
    },
    // PDF单篇下载
    pdfDown(id) {
      this.$http
        .get("/pdf?_id=" + id, {})
        .then((res) => {
          if (res.data.data.url) {
            window.open(res.data.data.url, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // word单篇下载
    wordDown(id) {
      this.$http
        .get("/word?_id=" + id, {})
        .then((res) => {
          if (res.data.data.url) {
            window.open(res.data.data.url, "_blank");
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 查看更多命中
    greater(index) {
      // console.log(index);
      this.one = index;
    },

    // 分页跳转
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.currentPage = val;
      window.scrollTo(0, 0);
      this.loadNode = true;
      this.loading_box = true;
      this.caseList();
    },
    // 每页显示条数
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.loadNode = true;
      this.loading_box = true;
      this.caseList();
    },

    btnClick(data) {
      //页码点击事件

      if (data != this.cur) {
        this.cur = data;
      }
      this.currentPage = this.cur;
      window.scrollTo(0, 0);

      this.loading_box = true;
      this.caseList();
    },
    pageClick() {
      // console.log("现在在" + this.cur + "页");
      this.currentPage = this.cur;
      window.scrollTo(0, 0);

      this.loading_box = true;
      this.caseList();
    },
    dataType(type) {
      if (type == "list") {
        if (this.picked == true) {
          this.picked = false;
          this.sortShow = false;
        }
      }
      if (type == "chart") {
        if (this.picked == false) {
          this.picked = true;
          this.sortShow = true;
        }
      }
    },
    reloads() {
      // 移除组件
      this.update = false;
      // 在组件移除后，重新渲染组件
      // this.$nextTick可实现在DOM 状态更新后，执行传入的方法。
      this.$nextTick(() => {
        this.update = true;
      });
    },
    seniorCase() {
      this.$router.push({ path: "/advanced" });
    },
    accuracy(val) {
      // console.log(val);
      if (val == "1") {
        window.localStorage.setItem("searchType", "1");
        this.activeName = "second";
      }
      if (val == "2") {
        window.localStorage.setItem("searchType", "2");
        this.activeName = "first";
      }
    },
    collectible(it) {
      console.log(it, this.exampleList, "2280");

      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          // user_id: store.getCookie("user_id"),
          docid: it._id,
          // role: store.getCookie("role"),
          doctype: 1,
          docname: it._source.Casename,
        };
        this.$http
          .post("/coll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            // this.caseList();
            for (let a = 0; a < this.exampleList.length; a++) {
              if (it._id == this.exampleList[a]._id) {
                if (this.exampleList[a]._source.coll == 0) {
                  this.$set(this.exampleList[a]._source, "coll", 1);
                  // this.exampleList[a]._source.coll=1
                  console.log(this.exampleList[a]._source.coll);
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    cancel(it) {
      if (window.localStorage.getItem("userType") == "ipuser") {
        let collOne = {
          docid: it._id,
        };
        this.$http
          .post("/delcoll", collOne)
          .then((res) => {
            // console.log(res);
            this.$message({
              message: res.data.message,
              type: "success",
            });
            // this.caseList();
            for (let a = 0; a < this.exampleList.length; a++) {
              if (it._id == this.exampleList[a]._id) {
                if (this.exampleList[a]._source.coll == 1) {
                  // this.$set(this.exampleList,this.exampleList[a]._source,{coll:1})
                  this.exampleList[a]._source.coll = 0;
                  console.log(this.exampleList[a]._source.coll);
                }
              }
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message({
          message: "请登录个人账号！！",
          type: "warning",
        });
      }
    },
    showEeharts() {
      var chart1 = this.$echarts.init(this.$refs.chart1);
      // console.log(this.wordData);
      let words = [];
      this.wordData.forEach((item) => {
        let word = {
          name: item.key,
          value: item.doc_count,
        };
        words.push(word);
      });

      var chart1Option = {
        title: {
          // text: '各省累计确诊-词云',//标题
          x: "center",
          textStyle: {
            fontSize: 10,
          },
        },
        // backgroundColor: "#fff", //F7F7F7
        tooltip: {
          show: true,
        },
        series: [
          {
            name: "关键词", //数据提示窗标题
            type: "wordCloud",
            sizeRange: [10, 12],
            // rotationRange: [-90, 90],
            rotationRange: [0, 0, 0, 0],
            // maskImage: maskImages,
            shape: "pentagon",
            width: "80%",
            height: "100%",
            drawOutOfBound: false,
            textStyle: {
              normal: {},
              color: function () {
                return (
                  "rgb(" +
                  [
                    Math.round(Math.random() * 200),
                    Math.round(Math.random() * 200),
                    Math.round(Math.random() * 200),
                  ].join(",") +
                  ")"
                );
              },
              emphasis: {
                shadowBlur: 10,
                shadowColor: "#333",
              },
            },
            left: "center",
            top: "center",
            right: null,
            bottom: null,
            width: "200%",
            height: "200%",
            data: words,
          },
        ],
      };
      chart1.setOption(chart1Option);

      let that = this;
      chart1.on("click", function (params) {
        let data = {
          key: params.data.name,
          doc_count: params.data.value,
        };
        that.wordClick(data);
        // 	var name = params.data.name;
        // 	var value = params.data.value;
        // var uniscid = params.data.uniscid;
        // 	console.log(name + ":" + value + ":" + uniscid);
      });
    },
    feeClick(msg) {
      // console.log(msg);
      var feeObj = {
        name: msg.name,
        lab: { start: "", end: "" },
        type: "fee",
      };
      // return
      let name = msg.name.replace(/\元/g, ""); // \:转义符
      if (name.includes("-")) {
        name = name.split("-");
        feeObj.lab.start = name[0];
        feeObj.lab.end = name[1];
      } else if (name == "<50") {
        feeObj.lab.start = "0";
        feeObj.lab.end = "50";
      } else if (name == "10000<") {
        feeObj.lab.start = "10000";
        feeObj.lab.end = "10000000";
      }
      this.fee_ = feeObj.lab;
      // console.log(feeObj.lab)
      if (!this.char_.includes("Fee")) {
        // let fee = ["and", "Fee", [feeObj.lab.start, feeObj.lab.end]];
        // this.condition.push(fee);
        // console.log('a')
        this.condition.push(["Fee", [feeObj.lab.start, feeObj.lab.end]]);
      } else {
        this.condition.forEach((item, index) => {
          if (item[0] == "Fee") {
            item[1] = [feeObj.lab.start, feeObj.lab.end];
          }
        });
      }
      this.Flushed();
    },

    getUser(msg) {
      // console.log(msg);

      if (msg.type == "time") {
        this.timeClick(msg);
        // this.picked = false;
      } else if (msg.type == "brief") {
        this.briefClick(msg);
      } else if (msg.type == "procedures") {
        this.proceduresClick(msg);
      } else if (msg.type == "fee") {
        this.feeClick(msg);
      }
    },
  },
  mounted() {},
  components: {
    // ComHeader,
    CHART,
    ComFooter,
    WORD,
  },
};
</script>

<style lang="less" scoped>
.background_box {
  // background: #f3ede3;
  // width: 100%;
  background: rgb(245, 239, 228);
  // width: 1350px;
  min-width: 1280px;
  // max-width: 1350px;
}
.box {
  // min-width: 1350px;
  width: 100%;
  background: url("../../../assets/imgs/raphael-schaller-GkinCd2enIY-unsplash.png");
  background-size: 100% 1000px;
  // background-repeat: no-repeat;
  // max-width: 1920px;
  // min-height: 1000px;
  // height: 100vh;
  // width: 100%;
  // min-width: 1280px;
  // max-width: 2000px;

  margin: auto;
}
.case {
  width: 1280px;
  min-width: 1280px;
  max-width: 1280px;
  margin: auto;
  // padding: 0 18%;
  // min-width: 1200px;
  min-height: calc(100vh - 60px);
  .breadcrumb {
    margin: 20px 0;
  }
  .advanced_search {
    // margin-left: ;
    display: flex;
    justify-content: center;
    .carousel {
      padding: 10px 20px 20px 10px;
      border-radius: 10px;
      // width: 20%;
      height: 150px;
      background: none !important;
      /deep/ .el-carousel__button {
        width: 10px;
      }
      .el-carousel__item h3 {
        display: inline-block;
        height: 120px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        // line-height: 50px;
        margin: 0;
        span {
          display: inline-block;
        }
      }

      .el-carousel__item:nth-child(2n) {
        // background-color: #99a9bf;
        background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
        background-size: 100% 100%;
      }

      .el-carousel__item:nth-child(2n + 1) {
        // background-image: url('../../../assets/imgs/背景图/9760eac49571416.jpg');
        background-image: url("../../../assets/imgs/背景图/raphael-schaller-GkinCd2enIY-unsplash.png");
        background-size: 100% 100%;
      }
    }
    .el-tabs {
      width: 79%;
      .el-tab-pane {
        .el-popover {
        }
        .el-input {
          // height: 20px;
          /deep/ .el-input__inner {
            // border-radius: 0;
          }
        }
        .el-button {
          margin: 0;
          border: 0;
          // border-radius: 0;
        }
      }
    }
    /deep/ .el-popover--plain {
      margin-left: 700px;
    }
  }
}
// 高级检索下拉框
.advancedDown {
  /deep/ .el-form-item {
    margin: 0 10px 10px 0;
    // height: 28px;
    width: 48%;
    .el-form-item__content {
      width: 75%;
      // margin-bottom: 20px;
      .el-input {
        // .el-input__inner {
        //   height: 28px;
        // }
      }
    }
    .el-button--primary {
      border-color: rgb(238, 198, 22);
    }
  }
}
.searchBtn {
  width: 100%;
  // height: 50px;
  /deep/.el-form-item__content {
    margin-left: 72%;
  }
}
.time {
  /deep/ .el-form-item__content {
    width: 70.5%;
    .el-input__inner {
      padding: 0 0 0 30px;
      font-size: 1px;
    }
  }
}
.popovertwo {
  background: white;
  width: 320px;
  padding: 10px;
  border-radius: 5px;
  .popoverbox {
    padding-bottom: 20px;
    border-bottom: 1px solid gold;
    h2 {
      display: inline-block;
      margin: 10px 0;
    }
    .el-radio {
      height: 20px;
      line-height: 20px;
      min-width: 36%;
      margin-right: 20px;
    }
  }
  .export {
    display: flex;
    justify-content: center;
    margin: 20px 0;
    .el-button {
      border: none;
    }
  }
}
.conditions {
  display: flex;
  // height: 32px;
  line-height: 32px;
  justify-content: space-between;
  margin: 10px 0 0 0;
  .condition {
    width: calc(100% - 100px);
    // position: relative;
    display: flex;
    span {
      // display: block;
    }
    // overflow: hidden;
    .eltags {
      width: calc(100% - 100px);
      display: inline-block;
      // max-width: 610px;
      // max-width: 810px;
      // margin-left: 60px;
      display: flex;
      flex-wrap: wrap;
    }
    .el-tag {
      margin: 0 0 5px 5px;
    }
  }
  .savebtn :hover {
    color: #409eff;
    cursor: pointer;
  }
}
.box_botton {
  display: flex;
  .box_left {
    width: 20%;
    max-width: 20%;
    padding: 0 10px 10px 0px;
    margin-right: 1%;

    border-radius: 5px;
    // height: 100vh;
    // min-height: 1000px;
    // max-height: 3000px;
    // background: white;

    margin-bottom: 2%;
    /deep/ .el-menu {
      // background: white;
      background: #faf1e8 !important;
      background-color: #faf1e8 !important;
      border: none;
      border-radius: 10px;
    }
    h2 {
      margin: 10px 0;
      // font-size: 18px;
      font-weight: 600;
      span {
        font-size: 28px;
        color: chocolate;
        font-weight: 600;
      }
    }
  }
  .box_right {
    width: 80%;
    position: relative;
    top: -20px;
    // background: white;
    .box_right_top {
      padding: 10px;
      // background: white;
      // background-color: rgb(250, 242, 234);
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      .el-select {
        width: 110px;
        height: 10px;
        color: violet !important;
      }
    }
    .types {
      .listPick {
        // color: #409eff;
        // background: #ecf5ff;
        // border-color: #b3d8ff;
        color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
        // border-radius: 4px;
      }
      .EChart {
        background: none !important;
      }
      .el-button:hover {
        // color: #409eff;
        // border-color: #c6e2ff;
        // background-color: #ecf5ff;
        color: #ddb361;
        background: #faf1ea;
        border-color: #ddb361;
      }
    }
    .box_main {
      // margin-top: 20px;
      // box-sizing: none !important;
      .box_main_list {
        margin: 10px 0 20px 0px;
        // height: 200px;
        // height: 300px;
        border-radius: 5px;
        padding: 10px;
        // background: #f8f7f6;
        background: #fbf2eb;
        .title {
          display: flex;
          justify-content: space-between;
          // margin-bottom: 10px;
          line-height: 28px;
          h2 {
            // width: 800px;
            width: 100%;
            font-size: 16px;
            font-weight: 600;
          }
        }
        .title :hover {
          // color: rgb(197, 197, 197);
          color: #cf8700;
          //  border-bottom:1px solid #cf8700;
        }
        .case {
          background: #cf8700;
          color: white;
          // display: inline-block;
          margin: 5px;
          // padding: 5px;
          border-radius: 5px;
        }
        .box_detail {
          margin-top: 10px;
          // height: 200px;
          // background: #ffffff;
          position: relative;
          background: #f0e1d5;
          padding: 18px;
          .basic {
            margin-bottom: 30px;
            font-size: 18px;
            display: flex;
            // align-items: center;
            .basic_left {
              width: 15%;
              // height: 56px;
              display: inline-block;
              padding: 20px 20px 10px 20px;
              border-right: 1px solid rgb(172, 112, 0);
              display: flex;
              justify-content: center;
              align-items: center;
            }
            .basic_right {
              width: 85%;
              padding-left: 10px;
              .basic_content {
                // min-width: 500px;
                width: 50%;
                div {
                  // display: block;
                  line-height: 30px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
              }
              // justify-content: space-around;
              // width: 500px;
              // p {
              //   // display: inline-block;
              //   height: 20px;
              //   line-height: 20px;
              //   min-width: 45%;
              //   // max-width: 50%;
              //   // margin: 5px;
              // }
            }
            .details {
              width: 85%;
              padding-left: 10px;
              overflow: hidden;
              -webkit-line-clamp: 2;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;

              p {
                line-height: 20px;
              }
            }
          }
          .card {
            margin: 20px 0 0 0;
            .mores {
              display: flex;
              justify-content: center;
              span {
                display: inline-block;
                cursor: pointer;
              }
            }
            p {
              line-height: 20px;
              overflow: hidden;
              -webkit-line-clamp: 5;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
            }
            .hits {
              line-height: 30px;
              display: flex;
              span {
                display: inline-block;
              }
            }
            /deep/ .el-tabs__content {
              // background: #f0e1d5;
              background: #fbf2eb;
            }
            /deep/ .el-tabs__nav-scroll {
              .el-tabs__item.is-active {
                color: #ddb361;
                // background: #f0e1d5;
                background: #fbf2eb;
                border-right-color: #dcdfe6;
                border-left-color: #dcdfe6;
              }
            }
            /deep/ .el-tabs__nav-wrap {
              // background: #fbf2eb;
              background: #f0e1d5;
            }
          }

          .detail {
          }
        }
      }
    }
  }
}
.collDown {
  width: 270px;

  display: flex;
  justify-content: flex-end;

  // position: relative;
  // top: 10px;
  // right: 0px;
  // text-align: right;
}
.batch :hover {
  font-weight: 600;
}
.batch {
  cursor: pointer;
}
/deep/ .el-tree-node__content {
  // margin: 5px 15px 5px 0;
  // min-height: 40px;
}
.region {
  /deep/ .el-tree-node {
    white-space: normal;
    // padding: 10px 0;
    // max-width: 170px;
    // line-height: 25px;
    // text-align: center;

    .el-tree-node__content {
      height: 100%;
      align-items: start;
      line-height: 30px;
    }
    // .el-tree-node__content {
    //   height: 100%;
    //   align-items: start;
    // }
    // font-size: 14px;
  }
}
.cityClass {
  /deep/ .el-tree-node__content {
    // height: 60px;
    // max-height: 60px !important;
    // display: inline-block;
    // margin: 5px 5px 5px 0;
  }
  /deep/ .custom-tree-node {
    // display: inline-block;
    // padding-right: 10px;
  }
  /deep/ .custom-tree-node {
    // margin: 10px 0;
    // padding-right: 10px;
    // width: 150px;

    // display: inline-block;
    // max-height: 50px;
  }
}
.sift_tree::-webkit-scrollbar {
  display: none;
}
.sift_tree {
  max-height: 450px;
  overflow-x: hidden;
  // overflow-y: scroll;
}
/deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
  background-color: #409eff;

  // color: #fff;
}
.more {
  cursor: pointer;
  color: #409eff;
  height: 30px;
  width: 100%;
  display: inline-block;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgb(250, 242, 234);
}
.brief_choose {
  //  min-height: 200px;max-height: 220px;overflow: auto;
}
// .region_choose {
//   width: 220px;
//   max-height: 220px;
//   overflow: auto;
//   /deep/ .el-tree-node {
//     // line-height: 28px;
//     white-space: normal;
//     // padding: 10px 0;
//     // max-width: 170px;
//     text-align: left;
//     // .el-tree-node__content {
//     //   height: 100%;
//     //   align-items: start;
//     // }
//   }
//   /deep/ .custom-tree-node {
//     // height: 100px;
//     padding-right: 10px;
//   }
//   /deep/ .el-tree-node__content {
//     margin-right: 15px;
//     height: 50px;
//   }
// }
#paging {
  span {
    display: inline-block;
    margin: 3px;
    width: 35px;
    height: 35px;
    line-height: 35px;
    text-align: center;
    color: pink;
    background: #fff;
    border-radius: 5px;
  }
  span.current-page,
  span:hover {
    color: #fff;
    background: pink;
  }
}
.page-bar {
  margin-bottom: 20px;
  // width: ;
  height: 50px;
  line-height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  ul {
    // display: inline-block;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 550px;
  }
}
// ul,li{
//     margin: 0px;
//     padding: 0px;
// }
li {
  list-style: none;
}
.page-bar li:first-child > a {
  margin-left: 0px;
}
.page-bar a {
  border: 1px solid #ddd;
  text-decoration: none;
  position: relative;
  float: left;
  padding: 6px 12px;
  margin-left: -1px;
  line-height: 1.42857143;
  color: #337ab7;
  cursor: pointer;
}
.page-bar a:hover {
  background-color: #eee;
}
.page-bar a.banclick {
  cursor: not-allowed;
}
.page-bar .active a {
  color: #fff;
  cursor: default;
  background-color: #337ab7;
  border-color: #337ab7;
}
.page-bar i {
  font-style: normal;
  color: #d44950;
  margin: 0px 4px;
  font-size: 12px;
}
.briefCss {
  width: 250px;
  min-height: 34px;
  max-height: 200px;
  height: auto;
  /deep/ span {
    width: 100%;
    word-break: normal;
    width: auto;
    display: block;
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
  }
}
.senior:hover {
  color: #6fb2f5;
}
.collection {
  img {
    width: 28px;
  }
}
.collection:hover img {
  cursor: pointer;
  // content: url("../../../assets/imgs/2.0/收藏3.png");
}
.mores01 {
  display: flex;
  justify-content: center;
  margin: 20px 0 0 0;
  span {
    display: inline-block;
    color: #e6a23c;
  }
  span:hover {
    color: #3ca2e6;
    cursor: pointer;
  }
}
.tit_input {
  /deep/ .el-input-group__append {
    border: none;
  }
  /deep/ .el-input-group__prepend {
    border: none;
  }
  /deep/ .el-input__inner {
    border: none;
    border-start-start-radius: 0px;
    border-end-start-radius: 0px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    // background: #fef7f0;
    background: #f7f1eb;
    border-right: #b7a974 1px solid;
    border-top: #b7a974 1px solid !important;
    border-bottom: #b7a974 1px solid;
    position: relative;
    top: 0px;
    height: 43px;
  }
}
.search_button {
  border-start-start-radius: 0px;
  border-end-start-radius: 0px;
  border-end-end-radius: 4px;
  border-start-end-radius: 4px;
}
.titSelect {
  // background: #fef7f0;
  background: #f7f1eb;
  height: 43px;
  // border: none;
  border-left: #b7a974 1px solid;
  // border-top: #b7a974 1px solid !important;
  border-bottom: #b7a974 1px solid;
  border-start-start-radius: 4px;
  border-end-start-radius: 4px;
  border-end-end-radius: 0px;
  border-start-end-radius: 0px;
  /deep/ .el-input__inner {
    text-align: center;
    // border-radius: 0;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
  }
  /deep/ .el-input__suffix-inner {
    // display: inline-block;
    // border: none;
    border-start-start-radius: 4px;
    border-end-start-radius: 4px;
    border-end-end-radius: 0px;
    border-start-end-radius: 0px;
    padding: 0 15px;
    // margin-top: 5px;
    position: relative;
    top: 2px;
    border-right: 1px #e8e3dd solid;
    i {
      position: relative;
      top: -2px;
    }
  }
}
/deep/ .wor {
  /deep/ div {
    /deep/ canvas {
      border-radius: 50px;
    }
  }
}
/deep/ .el-tree-node__expand-icon {
  position: relative;
  top: 3px;
}
.el-tree {
  background: #faf1e8;
}
.bac {
  /deep/ .el-input__inner {
    background: none;
  }
}
.sift_tree
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-checked
  > .el-tree-node__content {
  background-color: rgb(247, 26, 26);
  color: rgb(156, 65, 53);
}
.sift_tree
  .el-tree--highlight-current
  /deep/
  .el-tree-node.is-current
  > .el-tree-node__content {
  background-color: rgb(255, 10, 10);
  color: rgb(195, 64, 255);
}
.sift_tree {
  /deep/ .el-tree-node:focus > .el-tree-node__content {
    /*设置选中的样式 */
    // background-color: #dde9ff !important;
    background: none !important;
  }
  /deep/ .el-tree-node__content:hover {
    /*设置鼠标飘过的颜色 */
    // background: #eaf9ff !important;
    color: #e6a23c;

    background: none !important;
    .custom-tree-node {
      span {
        // font-weight: 900 !important;
      }
    }
  }
  /deep/ .el-tree-node__label {
  }

  /deep/
    .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    /*current选中的样式 */
    color: #e4b453;
    font-weight: bold;
    background: none !important;
    // background-color: #dde9ff !important;
  }
  /deep/ .custom-tree-node {
    // display: inline-block;
    padding-right: 10px;
  }
}
.box_left {
  /deep/ .el-submenu__title:hover {
    color: #e4b453;
    background: none !important;
  }
}
.down_icon {
  width: 20px;
  position: relative;
  top: 3px;
}
.radio_css {
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #cf8700;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: #e6a23c;
    border-color: #e6a23c;
  }
}
.word_tag {
  // word-break: normal;
  // width: auto;
  // display: block;
  // white-space: pre-wrap;
  // word-wrap: break-word;
  // overflow: hidden;
  // width: 90%;
  display: inline-block;
  // width: calc(100% - 50px);
  .el-tag {
    color: #fff;
    background-color: #e6a23c;
    border-color: #e6a23c;

    /deep/ .el-tag__close {
      color: #f7f7f7;
      //  background-color: #030303;
    }
    /deep/ .el-tag__close:hover {
      color: #e6a23c;
      background-color: #fdf6ec;
    }
  }
}
.key_txt {
  display: inline-block;
  display: flex;
  .key_tit {
    min-width: 70px;
    display: inline-block;
  }
  .key_box {
    display: inline-block;
  }
  span {
  }
}
.box_right_top {
  /deep/ .el-radio__input.is-checked + .el-radio__label {
    color: #cf8700;
  }
  /deep/ .el-radio__input.is-checked .el-radio__inner {
    background-color: #e6a23c;
    border-color: #e6a23c;
  }
  /deep/
    .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled)
    .el-radio__inner {
    box-shadow: 0 0 0px 0px #409eff;
  }
}
.video_img {
  width: 28px;
  cursor: pointer;
  position: absolute;
  right: 20px;
}

.box_main_ {
  /deep/ .el-loading-spinner {
    top: 120px;
    margin-top: -21px;
    width: 100%;
    text-align: center;
    position: absolute;
  }
}
</style>
<style>
.tool-tip {
  max-width: 400px;
  line-height: 20px;
}

.tip-class.el-tooltip__popper .popper__arrow {
  /* 上方箭头 */
  border-top-color: #fff !important;
  /* 下方箭头 */
  border-bottom-color: #fff !important;
}
.tip-class.el-tooltip__popper .popper__arrow:after {
  border-top-color: #fff !important;
  border-bottom-color: #fff !important;
}

/* tooltip主体部分 */
.tip-class.el-tooltip__popper {
  padding: 5 !important;
  border-radius: 4px !important;
  border-color: #e6e6e6 !important;
  box-shadow: 0px 0px 7px 0px rgba(42, 42, 42, 0.2) !important;
  max-width: 400px !important;
  line-height: 20px !important;
  max-height: 300px !important;
  overflow-x: hidden !important;
  overflow-y: scroll !important;
  text-align: center !important;
}
.tip-class.el-tooltip__popper::-webkit-scrollbar {
  /* display: none !important; */
}

.tip-class.el-tooltip__popper::-webkit-scrollbar {
  width: 10px;
  height: 6px;
}

.tip-class.el-tooltip__popper::-webkit-scrollbar-button {
  display: none;
}
.tip-class.el-tooltip__popper::-webkit-scrollbar-track {
  background: transparent;
}
.tip-class.el-tooltip__popper::-webkit-scrollbar-track-piece {
  background-color: transparent;
}
.tip-class.el-tooltip__popper::-webkit-scrollbar-thumb {
  background: rgba(144, 147, 153, 0.3);
  cursor: pointer;
  border-radius: 4px;
}
.tip-class.el-tooltip__popper::-webkit-scrollbar-corner {
  display: none;
}
.tip-class.el-tooltip__popper::-webkit-resizer {
  display: none;
}
</style>